module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0098.jpg?v=72ba2fb2";